import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Community } from '@app/_models/community';
import { Devices, DeviceConfig } from '@app/_models/devices';
import { AuthenticationService } from '@app/_services';
import { AccessManagementService } from '@app/_services/access-management.service';
import { DeviceService } from '@app/_services/device.service';
import { environment } from '@environments/environment';
import { faHome, faBuilding, faArrowRight, faSearch, faHouse, faCircleArrowRight } from '@fortawesome/free-solid-svg-icons';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-quick-access',
    templateUrl: './quick-access.component.html',
    styleUrls: ['./quick-access.component.css'],
    standalone: false
})
export class QuickAccessComponent implements OnInit {

  constructor(private accessManagementService: AccessManagementService, 
    private router: Router,
    private authenticationService: AuthenticationService,
    private deviceService: DeviceService,
    private toastr: ToastrService,
    private route: ActivatedRoute,) { }
  faHome = faHome;
  faBuilding = faBuilding;
  faArrowRight = faArrowRight;
  faSearch = faSearch;
  faHouse = faHouse;
  faCircleArrowRight = faCircleArrowRight;
  action: any;
  searchText!: string;
  
  subscriptions!: Community[];  
  devices!: Devices[];
  displaydevices!: Devices[];
  devconfigs!: DeviceConfig[];
  property_id: any;

  ngOnInit(): void {
    //this.action = this.route.snapshot.paramMap.get("action");
    this.route.params.subscribe((params: Params) => this.action = params['action']);
    
    this.subscriptions = JSON.parse(localStorage.getItem('user_subscriptions')!);
    this.devices = JSON.parse(localStorage.getItem('devices_available')!);
    this.route.params.subscribe((params: Params) => this.filterList(params['id']));
  }

  filterList(propertyid: number) {
    this.displaydevices = this.devices.filter(item => item.property_id == propertyid);
    this.property_id = propertyid;
  }

  goHome() {
    this.router.navigate(['/'])
  }

  operateGate(propertyid: number) {

    this.router.navigate(['/quick-access/operate/' + propertyid]);
  }

  

  checkSubscriptions() {
 
    
    //this.action = this.route.snapshot.paramMap.get("action");
    this.subscriptions = JSON.parse(localStorage.getItem('user_subscriptions')!);
    if (this.subscriptions.length == 0) {
      alert('You do not have any gate/community subscriptions. Use Find Community and request Access.');
    }

    if (this.subscriptions.length == 1) {
      this.router.navigate(['/quick-access/operate/' + this.subscriptions[0].id]);
    }

    if (this.subscriptions.length > 1) {
      this.router.navigate(['/quick-access/choose'])
    }

  }

  toggleDevice(event: any, devicename: any, deviceid: any) {

    var request = {
      "accessby": this.authenticationService.currentOfflineUserValue!.username,
      "devicename": devicename,
      "accessmethod": "public_ip"
    };

    this.devconfigs = JSON.parse(localStorage.getItem('dev_config')!);

    let temp = this.devconfigs.find(t => t.property_id == this.property_id);

    if (temp != undefined) {
      
    }

    environment.apiUrl
 
    if (event.target.checked === true) {
      this.deviceService.operateDeviceOffline(environment.apiUrl,request).subscribe(
        data => {
          this.toastr.success(data.message, 'Success');
        }, error => {
          request.accessmethod = "local_ip";
          this.deviceService.operateDeviceOffline(temp!.private_server_ip!,request).subscribe(
            data => {
              this.toastr.success(data.message, 'Success');
            },
            error => {
              this.toastr.error('Something went wrong.','Error');
            }
          
          );
          
        }
      );

      setTimeout(function() {
        var obj = document.getElementById(deviceid) as HTMLInputElement;;
        obj.checked = false;        
       
      }, 10000);

    }
  }


}
